module.exports = __webpack_public_path__ + "img/page_info_new.c4bc8c2.svg";